import SurveyAnswerContainer from './Container/SurveyAnswerContainer';
import { SurveyAnswerHeader } from './Header/SurveyAnswerHeader';

import type { User } from '@/types/directory/User';
import type { ReviewQuestion } from '@/types/review/ReviewQuestion';
import type { ReactNode } from 'react';

interface SurveyAnswerProps {
    reviewee?: User;
    showScoresToTheReviewee?: boolean;
    showCommentsToTheReviewee?: boolean;
    question: ReviewQuestion;
    renderAnswer: ReactNode | (() => ReactNode);
    isFirst: boolean;
    isLast: boolean;
    onNext: () => void;
    onPrevious?: () => void;
    onSkip?: () => void;
    onSubmit?: () => void;
    backgroundImageUrl?: string;
    showComment?: boolean;
    commentValue?: string;
    onCommentChange?: (value: string) => void;
    commentLabel?: string;
    enableTransitions?: boolean;
    transitionDurationMs?: number;
    transitionDirection?: 'next' | 'previous';
    contentKey?: string | number;
    currentIndex?: number;
    totalQuestions?: number;
    className?: string;
    isPreview?: boolean;
    includeOther?: boolean;
    isOtherSelected?: boolean;
    otherText?: string;
    onOtherTextChange?: (text: string) => void;
    isAnswerValid?: boolean;
    isSaving?: boolean;
    isSelfEvaluation?: boolean;
}

export const SurveyAnswer = ({
    reviewee,
    showScoresToTheReviewee,
    showCommentsToTheReviewee,
    question,
    renderAnswer,
    isFirst,
    isLast,
    onNext,
    onPrevious,
    onSkip,
    onSubmit,
    backgroundImageUrl,
    showComment,
    commentValue,
    onCommentChange,
    commentLabel,
    enableTransitions,
    transitionDurationMs,
    transitionDirection,
    contentKey,
    currentIndex,
    totalQuestions,
    isPreview,
    includeOther,
    isOtherSelected,
    otherText,
    onOtherTextChange,
    isAnswerValid,
    isSaving,
    isSelfEvaluation = false,
}: SurveyAnswerProps) => {
    return (
        <section className={'w-full py-10 sm:py-14 md:py-20'}>
            <div className={'mx-auto max-w-6xl px-6 sm:px-8'}>
                <SurveyAnswerHeader
                    reviewee={reviewee}
                    isSelfEvaluation={isSelfEvaluation}
                />

                <SurveyAnswerContainer
                    className={'survey-gap'}
                    question={question}
                    renderAnswer={renderAnswer}
                    reviewee={reviewee}
                    isFirst={isFirst}
                    isLast={isLast}
                    onNext={onNext}
                    onPrevious={onPrevious}
                    onSkip={onSkip}
                    onSubmit={onSubmit}
                    backgroundImageUrl={backgroundImageUrl}
                    showComment={showComment}
                    commentValue={commentValue}
                    onCommentChange={onCommentChange}
                    commentLabel={commentLabel}
                    enableTransitions={enableTransitions}
                    transitionDurationMs={transitionDurationMs}
                    transitionDirection={transitionDirection}
                    contentKey={contentKey}
                    showScoresToTheReviewee={showScoresToTheReviewee}
                    showCommentsToTheReviewee={showCommentsToTheReviewee}
                    currentIndex={currentIndex}
                    totalQuestions={totalQuestions}
                    isPreview={isPreview}
                    includeOther={includeOther}
                    isOtherSelected={isOtherSelected}
                    otherText={otherText}
                    onOtherTextChange={onOtherTextChange}
                    isAnswerValid={isAnswerValid}
                    isSaving={isSaving}
                />
            </div>
        </section>
    );
};
